import React, { useState, useEffect } from 'react';
import { Text, Icon } from 'porosys-ui';
import { Link } from 'react-router-dom';
import Card from '../../../common/ui/components/CardLayout/CardLayout';
import { markActionAsDone, pinAction } from '../api';
import moment from 'moment';
import handlePrintTimeAmPm from '../../../common/utils/print-am-pm-of-time';
import '../styles.scss';

const ActionCard = props => {
    const {
        isMeetingProfileToggled,
        action,
        handleToggleComments,
        handleEditAction,
        handleDeleteAction,
        focusedActionId,
        acl,
        setPinnedActionsCount,
        pinnedActionsCount,
        pinnedActions,
        setPinnedActions,
        logedInUser,
    } = props;

    const [isActionMarkedAsDone, setIsActionMarkedAsDone] = useState(false);
    const [isActionPinned, setIsActionPinned] = useState(false);

    const handlePinAction = () => {
        setIsActionPinned(!isActionPinned);
        if (handleCheckIsUserPinnedAction()) {
            const indexOfUserPinnedAction = action.participantsPinnedAction.indexOf(logedInUser._id);
            action.participantsPinnedAction.splice(indexOfUserPinnedAction, 1);

            // handle change pinned actions in list
            setPinnedActionsCount(pinnedActionsCount - 1);
            const indexOfPinnedActionToRemove = pinnedActions.findIndex(
                lookingAction => lookingAction._id === action._id
            );
            const remainingPinnedActions = [...pinnedActions];
            remainingPinnedActions.splice(indexOfPinnedActionToRemove, 1);
            setPinnedActions(remainingPinnedActions);
        } else {
            // handle change pinned actions in list
            setPinnedActions([...pinnedActions, action]);
            setPinnedActionsCount(pinnedActionsCount + 1);

            action.participantsPinnedAction.push(logedInUser._id);
        }
        pinAction(action._id);
    };
    const handleCheckIsUserPinnedAction = () => {
        if (!action.participantsPinnedAction) return false;
        return action.participantsPinnedAction.indexOf(logedInUser._id) > -1;
    };
    const handleMarkActionAsDone = () => {
        setIsActionMarkedAsDone(!isActionMarkedAsDone);
        markActionAsDone(action._id);
    };
    const handleCheckActionIsMarkDone = () => {
        return action.markedAsDone;
    };
    const handleCheckUserCouldMarkAsDone = id => {
        return action.assignee === id;
    };

    useEffect(() => {
        setIsActionMarkedAsDone(handleCheckActionIsMarkDone());
        setIsActionPinned(handleCheckIsUserPinnedAction());
    }, []);

    return (
        <Card
            classes={`summary-card ${focusedActionId === action._id ? 'focused' : ''}`}
            header={
                <>
                    <div className="flex">
                        <Text variant="subtitle1">
                            {isMeetingProfileToggled ? (
                                <>
                                    <Link target="_blank" to={`/actions/${action._id}`}>
                                        {action.title}{' '}
                                    </Link>{' '}
                                    | {action.meeting.title}
                                </>
                            ) : (
                                <>
                                    {action.title} |{' '}
                                    <Link target="_blank" to={`/meetings/${action.meeting._id}`}>
                                        {action.meeting.title}{' '}
                                    </Link>
                                </>
                            )}
                        </Text>

                        <div className="spacer" />
                        <Icon name="clock" classes={{ root: 'text-muted' }} />
                        <div className="spacer lv-1" />
                        <Text classes={{ root: 'text-muted' }} variant="caption">
                            {moment(action.dueDate).format('YYYY/MM/DD')}{' '}
                            {moment(action.dueDate).subtract('3', 'hours').subtract('25', 'minutes').format('hh:mm')}{' '}
                            {handlePrintTimeAmPm(action.dueDate)}{' '}
                        </Text>
                    </div>
                    <div className="actions-btn">
                        {handleCheckUserCouldMarkAsDone(logedInUser._id) && !acl && (
                            <button
                                className="btn"
                                onClick={() => {
                                    handleMarkActionAsDone();
                                }}
                            >
                                <Text>
                                    <span className={isActionMarkedAsDone ? 'isToggled' : 'notToggled'}>
                                        <Icon fontSize={1} name="checkCircle" />
                                    </span>
                                </Text>
                            </button>
                        )}
                        <button className="btn" onClick={() => handleToggleComments(action._id)}>
                            <Icon fontSize={1} name="comments" />
                        </button>
                        {!acl && (
                            <>
                                <button className="btn" onClick={() => handlePinAction()}>
                                    <Text>
                                        <span className={isActionPinned ? 'isToggled' : 'notToggled'}>
                                            <Icon fontSize={1} name="mapPin" />
                                        </span>
                                    </Text>
                                </button>
                            </>
                        )}
                        {acl && acl.delete && (
                            <button className="btn delete-button" onClick={() => handleDeleteAction(action._id)}>
                                <Icon fontSize={1} name="trash" />
                            </button>
                        )}
                        {acl && acl.edit && (
                            <button className="btn" onClick={() => handleEditAction(action)}>
                                <Icon fontSize={1} name="pen" />{' '}
                            </button>
                        )}
                    </div>
                </>
            }
            content={
                <div>
                    <Text variant="body1" classes={{ root: 'description text-muted' }}>
                        {action.description}
                    </Text>
                    <br />
                    <div className="flex participants">
                        {action.participants.map((participant, i) => (
                            <>
                                <Text>
                                    <span
                                        key={i}
                                        className={
                                            handleCheckUserCouldMarkAsDone(participant._id) ? 'isToggled' : 'notToggled'
                                        }
                                    >
                                        <Icon name="user" fontSize={1} /> {participant.fullname}
                                    </span>
                                </Text>
                                <div className="spacer lv-2" />
                            </>
                        ))}
                    </div>
                </div>
            }
        ></Card>
    );
};

export default ActionCard;
